import { render, staticRenderFns } from "./admin-home.vue?vue&type=template&id=236a4451&scoped=true&"
import script from "./admin-home.vue?vue&type=script&lang=js&"
export * from "./admin-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a4451",
  null
  
)

export default component.exports